module.exports = __webpack_public_path__ + "static/media/btn_sputnik_active.288b67e3.png";